export default "__VITE_ASSET__1f7aeb25__"